import React from 'react';
import { VerticalList, showInformationDialog } from 'ui-lib';
import componentCss from './component.css';
export const showSavingErrorDialog = (errors: React.ReactNode | string[]): void => {
    let content: React.ReactNode = errors;
    if (errors instanceof Array) {
        content = <VerticalList className={componentCss['vertical-list']}
                                listItems={errors.map((item, index) => ({ key: index, title: '', content: item }))}/>;
    }
    showInformationDialog({
        modalType: 'error',
        title: 'Error',
        width: '500px',
        content: content
    });
};